<template>
    <div>
        <table class="bm-table" style="margin:0px;">
            <tr class="table-header">
                <td colspan="2" style="text-align: center">Alignment Selection</td>
            </tr>
            <tr>
                <td class="bm-table-name">Query</td>
                <td class="bm-table-ope">
                    <el-select
                            v-model="query_val"
                            filterable
                            remote
                            reserve-keyword
                            placeholder
                    >
                        <el-option
                                v-for="item in options_query"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id"
                        ></el-option>
                    </el-select>
                </td>
            </tr>
            <tr>
                <td class="bm-table-name">Target</td>
                <td class="bm-table-ope">
                    <el-select
                            v-model="target_val"
                            filterable
                            remote
                            reserve-keyword
                            placeholder
                    >
                        <el-option
                                v-for="item in options_target"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id"
                        ></el-option>
                    </el-select>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import axios from "axios";
    import global_ from "../units/Global";
    import Highcharts from 'highcharts';
    import gantt from 'highcharts/modules/gantt';
    gantt(Highcharts);

    export default {
        name: "ProteinSelector",
        data() {
            return {
                website: global_.website,
                loading: true,

                evalue_slider: [0, 60],
                marks: {
                    0: '0',
                    10: '1e-6',
                    30: '1e-4',
                    60: '0.05',
                    80: '1',
                    100: '100',
                },
                coverage_val: [0, 100],
                identity_val: [0, 100],
                hits_chart_height: "0px",
                current_hits:[],
                options_query:[],
                query_val: "",
                options_target:[],
                target_val: "",
                pdb_id: "",
            }
        },
        props: {
            jobid: String,
        },
        watch: {
            query_val(query_id) {
                // console.log("query_val", query_id);
                if(query_id.match(RegExp(/Query_/))){
                    this.target_init(query_id);
                }
            },
            target_val(accession) {
                // console.log(accession);
                this.getvaluePDB(accession);
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.target_init("Query_1");
                this.query_init();
            },
            target_init(query_id){
                if (this.jobid !== "") {
                    let url = `${this.website}/api/align_select/${this.jobid}/`;
                    // console.log(url);
                    axios.get(url).then((res) => {
                        let current_target = res.data.results[query_id];
                        this.options_target = current_target.map((item, i) => {
                            let gene_name = item['gene_name'];
                            let accession = item['accession'];
                            let pdb_id = item['pdb_id'];
                            let pdb_chr = "";
                            if(pdb_id !== "") pdb_chr = " | " + pdb_id;
                            if (i === 0) {
                                this.target_val = `${accession}${pdb_chr} (${gene_name})`;
                                // console.log("query_id", query_id);
                                this.getvaluePDB(accession);
                                this.getAlignmentInfo(query_id);
                                // this.$store.commit('currentProteinMutation', item);
                                // console.log("currentProteinMutation", this.$store.state.current_protein)
                            }
                            return {
                                value: `${gene_name}`,
                                label: `${accession}${pdb_chr} (${gene_name})`,
                                id: `${accession}${pdb_chr}`,
                            };
                        });

                    });
                } else {
                    this.options = [];
                }
            },
            getvaluePDB() {
                this.source_db = "AlphaFold";
                let sep = this.target_val.split(" | ");
                // console.log("sep>>>", sep)
                if (sep.length > 1) {
                    this.value_pdb = sep[1].split(" ")[0];
                    this.accession = sep[0];
                    this.source_db = "PDB"
                }else{
                    this.accession = this.target_val.split(" ")[0];
                }
                // console.log("this.source_db", this.source_db);
                // console.log("value_pdb", this.value_pdb)
                // console.log("this.accession", this.accession)
                if(this.source_db === "AlphaFold"){
                    this.getProteinInfo(this.accession)
                }else{
                    this.getProteinPDB()
                }
                
            },
            getProteinPDB(){
                let url = `https://www.ebi.ac.uk/pdbe/api/mappings/uniprot/${this.value_pdb}`;
                // console.log("url>>>>", url)
                // console.log("this.accession", this.accession)
                axios.get(url).then((res) => {
                    // console.log(res.data[this.value_pdb.toLowerCase()]['UniProt'])
                    let mappings = res.data[this.value_pdb.toLowerCase()]['UniProt'][this.accession]['mappings'][0];

                    // console.log(mappings)
                    let chain = mappings['chain_id'];
                    let start = mappings['unp_start'];
                    let end = mappings['unp_end'];
                    switch (this.value_pdb) {
                        case "6YOV":
                            start = 141;
                            end = 208;
                            break;
                        case "6T90":
                            start = 138;
                            end = 210;
                            break;
                    }

                    this.getProteinSource(chain, start, end)
                });
            },
            getProteinSource(chain, start, end) {
                chain,
                start,
                end
                let url = `https://www.ebi.ac.uk/proteins/api/proteins/${this.accession}`;
                // console.log("url>>>>", url)
                // console.log("pdb_start>>>>", start)
                // console.log("this.accession", this.accession)
                // console.log("this.source_db", this.source_db)
                axios.get(url).then((res) => {
                    // console.log("res>>>", res)
                    let sequence = res.data['sequence']['sequence'];
                    let cut_sequence = sequence.substring(start - 1, end)
                    let cut_seq_len = cut_sequence.length;
                    let seq_len = sequence.length;
                    let coverage = cut_seq_len * 100 / seq_len;
                    // let pdb_url = `https://ftp.wwpdb.org/pub/pdb/data/structures/divided/mmCIF/kx/${this.value_pdb}.cif.gz`;
                    let pdb_url = `https://files.rcsb.org/download/${this.value_pdb}.pdb.gz`;
                    // console.log("sequence", sequence)
                    // console.log("cut_sequence", cut_sequence)
                    // console.log("cut_sequence", coverage.toFixed(3))
                    // console.log("pdb_url", pdb_url)
                    this.$store.commit("currentProteinMutation", {
                        source_db: this.source_db,
                        accession: this.accession,
                        description: "",
                        info: sequence,
                        natural: sequence,
                        natural_seq: sequence,
                        pdb_id: this.value_pdb,
                        pdb_chain: chain,
                        pdb_seq: cut_sequence,
                        pdb_start: start - 1,
                        score: [],
                        pdb_url: pdb_url,
                    });
                });
            },
            getProteinInfo(accession) {
                // console.log("getProteinInfo", accession, this.query_val)
                accession = accession.split(" ")[0];
                let url = `${this.website}/api/protein_info/${accession}/`;
                // console.log(url);
                axios.get(url).then((res) => {
                    let info = res.data.results[0];
                    let current_protein = {};
                    current_protein['accession'] = accession;
                    current_protein['pdb_url'] = info['pdb_url'].replace(/https:\/\/alphafold.ebi.ac.uk\/files/, global_.source);
                    // current_protein['pdb_url'] = info['pdb_url'].replace(/https:\/\/alphafold.ebi.ac.uk\/files/, "source/pdb");
                    current_protein['natural_seq'] = info['sequence'];
                    current_protein['query_id'] = this.query_val;
                    current_protein['score'] = info['score'];
                    current_protein['source_db'] = this.source_db;
                    this.$store.commit('currentProteinMutation', current_protein);
                    // this.params['source']['pdb'] = this.protein_pdb;
                    // this.params['source']['sequence'] = this.protein_sequence;
                    // this.$store.commit('naturalSeqMutation', this.protein_sequence);
                    // console.log("currentProteinMutation", this.$store.state.current_protein)
                });
            },
            query_init() {
                if (this.jobid !== "") {
                    let url = `${this.website}/api/align_query/${this.jobid}/`;
                    // console.log(url);
                    axios.get(url).then((res) => {
                        // this.current_query = res.data.results;
                        this.options_query = res.data.results.map((item, i) => {
                            let title = item['title'];
                            let id = item['id'];
                            if (i === 0) {
                                this.query_val = `${title}`;
                                // this.$emit("currentProteinMutation", item);
                            }
                            return {
                                value: `${id}`,
                                label: `${title} (${id})`,
                                id: `${id}`,
                            };
                        });
                    });
                } else {
                    this.options = [];
                }
            },
            getAlignmentInfo(query_id) {
                let url = `${this.website}/api/align_info/${this.jobid}/${query_id}/`;
                // console.log(url);
                axios.get(url).then((res) => {
                    // console.log("***", res);
                    this.$store.commit('alignHitsMutation', res.data.results);
                    // console.log("alignHitsMutation", this.$store.state.align_hits)
                });
            },
            evalueFormatTooltip(val) {
                return this.marks[val];
            },
            percentTooltip(val) {
                return val + " %";
            },
        }
    }
</script>

<style scoped>
    table {
        border: 1px solid #ccc;
        color: #4b6584;
        border-top: none;
        margin-bottom: 20px;
    }

    .bm-table td {
        border: 1px solid #ccc;
        padding: 5px 10px 5px 0;
    }

    .bm-table tr {
        border: 1px solid #ccc;
    }

    .bm-table-name {
        width: 120px;
        text-align: right;
        background: #dfe4ea;
    }

    .bm-table-ope {
        width: 210px;
        padding: 0px !important;
    }

    .hr-header {
        /*border-bottom: 1px solid #a4b0be;*/
        padding-bottom: 0px;
    }

    .hr-header p {
        margin-bottom: 0px;
        background: #ffffff;
        width: 331px;
        font-size: 14px;
        padding: 3px 10px 3px 10px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #a4b0be;
        border-bottom: none;
        text-align: center;
    }

    /deep/ .el-input__inner {
        height: 30px;
        border: none !important;
        background: transparent !important;
    }

    /deep/ .el-select-dropdown__list {
        margin-bottom: 25px !important;
        padding: 0px !important;
    }

    /deep/ .el-input__icon {
        line-height: 30px;
    }

    /deep/ .el-select-dropdown__item {
        font-size: 14px;
        padding: 0 10px !important;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #606266;
        height: 34px;
        line-height: 34px;
        box-sizing: border-box;
        cursor: pointer;
    }

    /deep/ .el-dropdown-menu__item {
        list-style: none;
        line-height: 22px !important;
        padding: 0 8px;
        margin: 0;
        font-size: 4px;
        color: #606266;
        cursor: pointer;
        outline: 0;
    }

</style>
